import { render, staticRenderFns } from "./FeaturedContent2.vue?vue&type=template&id=65837472&scoped=true"
import script from "./FeaturedContent2.vue?vue&type=script&lang=js"
export * from "./FeaturedContent2.vue?vue&type=script&lang=js"
import style0 from "./FeaturedContent2.vue?vue&type=style&index=0&id=65837472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65837472",
  null
  
)

export default component.exports